/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S6_Label_PhoneInputs */

const tr_iletisim_s6_label_phone = /** @type {(inputs: Iletisim_S6_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const en_iletisim_s6_label_phone = /** @type {(inputs: Iletisim_S6_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const de_iletisim_s6_label_phone = /** @type {(inputs: Iletisim_S6_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const ru_iletisim_s6_label_phone = /** @type {(inputs: Iletisim_S6_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телефон`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Iletisim_S6_Label_PhoneInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s6_label_phone = /** @type {((inputs?: Iletisim_S6_Label_PhoneInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S6_Label_PhoneInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s6_label_phone(inputs)
	if (locale === "de") return de_iletisim_s6_label_phone(inputs)
	if (locale === "ru") return ru_iletisim_s6_label_phone(inputs)
	return tr_iletisim_s6_label_phone(inputs)
});